import { cx } from '@linaria/atomic';
import { useTranslation } from '@frontend/i18n';
import { NewBadgeStyles } from './new-badge.styles';

type NewBadgeProps = {
  background?: 'light' | 'dark';
  className?: string;
};

/**
 *
 * @param `background` NewBadge needs to know what background it is on so that it is legible
 * however, since the only dark background in our app now is the global nav, we can assign a default of 'light'
 */
export const NewBadge = ({ background = 'light', className }: NewBadgeProps = {}) => {
  const { t } = useTranslation();
  return (
    <p
      className={cx(NewBadgeStyles.base, background === 'dark' ? NewBadgeStyles.dark : NewBadgeStyles.light, className)}
    >
      {t('New')}
    </p>
  );
};
